/**
 * The signed-out screens: sign in, badge scan, second factor.
 *
 * The first thing anybody reads, and the one place the language switcher has to
 * work before there is an account to remember the choice against.
 */

export const auth = {
  'login.tagline': 'Kontrola i unapređenje — prijave i 5S sa pogona.',
  'login.employeeCode': 'Šifra zaposlenog',
  'login.employeeCode.placeholder': 'npr. 1042',
  'login.password': 'Lozinka',

  /*
   * Prva prijava.
   *
   * Aktivacioni kod jeste lozinka — postavlja se kao lozinka i server ga tako
   * provjerava — pa se unosi u isto polje. Ali čovjek koji drži papirić na
   * kojem piše „Aktivacioni kod" ne zna da to treba ukucati pod „Lozinka",
   * i to je bio cijeli razlog zašto niko nije mogao da uđe.
   */
  'login.firstTime': 'Prvi put se prijavljujete?',
  'login.firstTime.switch': 'Unesite aktivacioni kod',
  'login.firstTime.back': 'Imate svoju lozinku? Prijavite se njome.',
  'login.activationCode': 'Aktivacioni kod',
  'login.activationCode.hint':
    'Osam znakova sa papirića koji ste dobili od nadređenog. Odmah nakon prijave postavljate svoju lozinku.',
  'login.forgotPassword': 'Zaboravili ste lozinku?',
  'login.remember': 'Zapamti me na ovom uređaju',
  'login.remember.hint': 'Isključite na zajedničkom računaru u pogonu.',
  'login.submit': 'Prijavi se',
  'login.failed': 'Prijava nije uspjela.',
  'login.or': 'ili',
  'login.scanBadge': 'Prijava skeniranjem kartice',
  'login.offlineNotice':
    'Radi i bez signala. Prijava se sačuva na telefonu i pošalje sama kad se veza vrati.',

  'login.badge.working': 'Prijava…',
  'login.badge.hint': 'Držite karticu ispred kamere. Kod se očita sam.',
  'login.badge.back': 'Nazad na prijavu lozinkom',
  'login.badge.failed': 'Kartica nije prepoznata.',

  'login.twoFactor.accepted': 'Lozinka je prihvaćena. Ostao je još kod.',
  'login.twoFactor.appCode': 'Kod iz aplikacije',
  'login.twoFactor.appCode.hint': 'Šestocifreni kod iz aplikacije na telefonu.',
  'login.twoFactor.recoveryCode': 'Rezervni kod',
  'login.twoFactor.recoveryCode.hint':
    'Jedan od kodova koje ste sačuvali pri uključivanju zaštite. Vrijedi samo jednom.',
  'login.twoFactor.confirm': 'Potvrdi',
  'login.twoFactor.failed': 'Potvrda nije uspjela.',
  'login.twoFactor.lostPhone': 'Izgubio sam telefon',
  'login.twoFactor.haveAppCode': 'Imam kod iz aplikacije',
  'login.twoFactor.back': 'Nazad',
  // The reader has no control to press, so the only way anybody learns it
  // works is a sentence saying so.
  'login.reader.hint': 'Ako je čitač priključen, samo provucite karticu — ništa ne treba kliknuti.',
  'login.reader.working': 'Kartica je pročitana, prijavljujemo vas…',
  'login.reader.codeRead': 'Šifra je učitana s kartice. Unesite lozinku.',
} as const

export type AuthSlice = Record<keyof typeof auth, string>
